// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"da786d3e","791":"457b09ad"}[chunkId] + ".chunk.js";
};